import { createSlice } from "@reduxjs/toolkit"
import {
  addTheoreticalTrainingParticipant,
  createTheoreticalTraining,
  deleteTheoreticalTraining,
  deleteTheoreticalTrainingParticipant,
  getAllTheoreticalTrainings,
  getCandidateTheoreticalAssessmentDetails,
  getMatchedTheoreticalCandidates,
  getTheoreticalAssessmentQuestions,
  getTheoreticalParticipantAssessmentDetails,
  getTheoreticalTrainingParticipants,
  getTrainingMaterialDetails,
  getTrainingMaterialList,
  markMultipleTheoreticalTrainingParticipantAttendance,
  markTheoreticalTrainingParticipantAttendance,
  resetTheoreticalTrainingAssessment,
  submitTheoreticalParticipantAssessment,
  theoreticalParticipantOpenAssessment,
  updateTheoreticalTraining,
} from "store/actions/theoreticalTrainingAction"

const payloadInitialState = {
  limit: 50,
  page_number: 1,
  order_by: 1,
  filters: {
    is_saudi: null,
    keyword: "",
    date_range: [],
  },
}

const participantFiltersInitialState = {
  limit: 50,
  page_number: 1,
  training_uuid: null,
  filters: {
    keyword: "",
    type: 0,
    job_title_ids: [],
  },
}

const initialState = {
  loading: false,
  isLoading: false,
  isGettingDetails: false,
  theoreticalTrainings: [],
  theoreticalTrainingDetails: {},
  materialList: [],
  theoreticalParticipants: [],
  perPage: 50,
  totalPages: null,
  currentPage: null,
  totalCount: null,
  loadingInterviewQ: false,
  theoreticalAssessmentQuestions: [],
  theoreticalMatchedCandidates: [],
  isMatching: false,
  totalPages1: null,
  currentPage1: null,
  totalCount1: null,
  candidatesMatchedCount: null,
  participantAssessmentDetails: {},
  participantAssessmentQuestions: [],
  show_enable_assessment_for_all: null,
  participants_count: 0,
  attendance_count: 0,
  payload: payloadInitialState,
  isShowFilter: false,
  activeTab: 0,
  participantsPayload: participantFiltersInitialState,
  assessmentAllowedTime: 0,
}

const theoreticalSlice = createSlice({
  name: "Theoretical Training",
  initialState,
  reducers: {
    setPayload: (state, action) => {
      state.payload = { ...state.payload, ...action.payload }
    },
    setParticipantsPayload: (state, action) => {
      state.participantsPayload = {
        ...state.participantsPayload,
        ...action.payload,
      }
    },

    resetPayload: state => {
      state.payload = payloadInitialState
    },
    resetParticipantsPayload: state => {
      state.participantsPayload = participantFiltersInitialState
    },
    toggleFilterVisibility: state => {
      state.isShowFilter = !state.isShowFilter
    },
    setActiveTab: (state, action) => {
      state.activeTab = action.payload
    },
  },
  extraReducers: builder => {
    builder
      .addCase(getAllTheoreticalTrainings.pending, state => {
        state.loading = true
        state.totalPages = null
        state.totalCount = null
        state.currentPage = null
      })
      .addCase(getAllTheoreticalTrainings.fulfilled, (state, action) => {
        state.loading = false
        const { success, data } = action.payload
        if (success) {
          const { total_records, current_page, total_pages } =
            action.payload || {}
          state.theoreticalTrainings = data
          state.totalPages = total_pages
          state.totalCount = total_records
          state.currentPage = current_page
        }
      })
      .addCase(getAllTheoreticalTrainings.rejected, (state, action) => {
        state.loading = false
      })

    builder
      .addCase(deleteTheoreticalTraining.pending, state => {
        state.isLoading = true
      })
      .addCase(deleteTheoreticalTraining.fulfilled, (state, action) => {
        state.isLoading = false
      })
      .addCase(deleteTheoreticalTraining.rejected, (state, action) => {
        state.isLoading = false
      })

    builder
      .addCase(createTheoreticalTraining.pending, state => {
        state.isLoading = true
      })
      .addCase(createTheoreticalTraining.fulfilled, (state, action) => {
        state.isLoading = false
      })
      .addCase(createTheoreticalTraining.rejected, (state, action) => {
        state.isLoading = false
      })

    builder
      .addCase(updateTheoreticalTraining.pending, state => {
        state.isLoading = true
      })
      .addCase(updateTheoreticalTraining.fulfilled, (state, action) => {
        state.isLoading = false
      })
      .addCase(updateTheoreticalTraining.rejected, (state, action) => {
        state.isLoading = false
      })

    builder
      .addCase(getTrainingMaterialList.pending, state => {})
      .addCase(getTrainingMaterialList.fulfilled, (state, action) => {
        state.loading = false
        const { success, data } = action.payload || {}
        if (success) {
          state.materialList = data
        }
      })
      .addCase(getTrainingMaterialList.rejected, (state, action) => {})

    builder
      .addCase(getTrainingMaterialDetails.pending, state => {
        state.isGettingDetails = true
        state.theoreticalTrainingDetails = {}
      })
      .addCase(getTrainingMaterialDetails.fulfilled, (state, action) => {
        state.isGettingDetails = false
        const { success, data } = action.payload || {}
        if (success) {
          state.theoreticalTrainingDetails = data
        }
      })
      .addCase(getTrainingMaterialDetails.rejected, (state, action) => {
        state.isGettingDetails = false
      })

    builder
      .addCase(getTheoreticalTrainingParticipants.pending, state => {
        state.isLoading = true
        state.theoreticalParticipants = []
        state.totalPages = null
        state.totalCount = null
        state.currentPage = null
        state.show_enable_assessment_for_all = null
        state.attendance_count = 0
        state.participants_count = 0
      })
      .addCase(
        getTheoreticalTrainingParticipants.fulfilled,
        (state, action) => {
          state.loading = false
          const { success, data } = action.payload || {}
          if (success) {
            const {
              total_records,
              current_page,
              total_pages,
              show_enable_assessment_for_all,
              attendance_count,
              participants_count,
            } = action.payload || {}
            state.theoreticalParticipants = data
            state.totalPages = total_pages
            state.totalCount = total_records
            state.currentPage = current_page
            state.show_enable_assessment_for_all =
              show_enable_assessment_for_all
            state.attendance_count = attendance_count
            state.participants_count = participants_count
            state.isLoading = false
          }
        }
      )
      .addCase(getTheoreticalTrainingParticipants.rejected, (state, action) => {
        state.isLoading = false
      })

    builder
      .addCase(addTheoreticalTrainingParticipant.pending, state => {
        state.isLoading = true
      })
      .addCase(addTheoreticalTrainingParticipant.fulfilled, (state, action) => {
        state.isLoading = false
      })
      .addCase(addTheoreticalTrainingParticipant.rejected, (state, action) => {
        state.isLoading = false
      })

    builder
      .addCase(markTheoreticalTrainingParticipantAttendance.pending, state => {
        state.isLoading = true
      })
      .addCase(
        markTheoreticalTrainingParticipantAttendance.fulfilled,
        (state, action) => {
          state.isLoading = false
        }
      )
      .addCase(
        markTheoreticalTrainingParticipantAttendance.rejected,
        (state, action) => {
          state.isLoading = false
        }
      )

    builder
      .addCase(
        markMultipleTheoreticalTrainingParticipantAttendance.pending,
        state => {
          state.isLoading = true
        }
      )
      .addCase(
        markMultipleTheoreticalTrainingParticipantAttendance.fulfilled,
        (state, action) => {
          state.isLoading = false
        }
      )
      .addCase(
        markMultipleTheoreticalTrainingParticipantAttendance.rejected,
        (state, action) => {
          state.isLoading = false
        }
      )

    builder
      .addCase(deleteTheoreticalTrainingParticipant.pending, state => {
        state.isLoading = true
      })
      .addCase(
        deleteTheoreticalTrainingParticipant.fulfilled,
        (state, action) => {
          state.isLoading = false
        }
      )
      .addCase(
        deleteTheoreticalTrainingParticipant.rejected,
        (state, action) => {
          state.isLoading = false
        }
      )

    builder
      .addCase(getTheoreticalAssessmentQuestions.pending, state => {
        state.loadingInterviewQ = true
        state.theoreticalAssessmentQuestions = []
      })
      .addCase(getTheoreticalAssessmentQuestions.fulfilled, (state, action) => {
        state.loadingInterviewQ = false
        const { success, data, total_allow_time } = action.payload || {}
        if (success) {
          state.theoreticalAssessmentQuestions = data
          state.assessmentAllowedTime = total_allow_time
        }
      })
      .addCase(getTheoreticalAssessmentQuestions.rejected, (state, action) => {
        state.loadingInterviewQ = false
      })

    builder
      .addCase(submitTheoreticalParticipantAssessment.pending, state => {
        state.isLoading = true
      })
      .addCase(
        submitTheoreticalParticipantAssessment.fulfilled,
        (state, action) => {
          state.isLoading = false
        }
      )
      .addCase(
        submitTheoreticalParticipantAssessment.rejected,
        (state, action) => {
          state.isLoading = false
        }
      )

    builder
      .addCase(getMatchedTheoreticalCandidates.pending, state => {
        state.isMatching = true
        state.theoreticalMatchedCandidates = []
        state.totalPages1 = null
        state.totalCount1 = null
        state.currentPage1 = null
      })
      .addCase(getMatchedTheoreticalCandidates.fulfilled, (state, action) => {
        state.isMatching = false
        const { success, data } = action.payload
        if (success) {
          const { total_records, current_page, total_pages } =
            action.payload || {}
          state.theoreticalMatchedCandidates = data
          state.totalPages1 = total_pages
          state.totalCount1 = total_records
          state.currentPage1 = current_page
        }
      })
      .addCase(getMatchedTheoreticalCandidates.rejected, (state, action) => {
        state.isMatching = false
      })

    builder
      .addCase(getTheoreticalParticipantAssessmentDetails.pending, state => {
        state.isGettingDetails = true
        state.participantAssessmentDetails = {}
        state.participantAssessmentQuestions = []
      })
      .addCase(
        getTheoreticalParticipantAssessmentDetails.fulfilled,
        (state, action) => {
          state.isGettingDetails = false
          const { success, data, questions } = action.payload || {}
          if (success) {
            state.participantAssessmentDetails = data
            state.participantAssessmentQuestions = questions
          }
        }
      )
      .addCase(
        getTheoreticalParticipantAssessmentDetails.rejected,
        (state, action) => {
          state.isGettingDetails = false
        }
      )

    builder
      .addCase(theoreticalParticipantOpenAssessment.pending, state => {
        state.isLoading = true
      })
      .addCase(
        theoreticalParticipantOpenAssessment.fulfilled,
        (state, action) => {
          state.isLoading = false
        }
      )
      .addCase(
        theoreticalParticipantOpenAssessment.rejected,
        (state, action) => {
          state.isLoading = false
        }
      )

    builder
      .addCase(getCandidateTheoreticalAssessmentDetails.pending, state => {
        state.isGettingDetails = true
        state.participantAssessmentDetails = {}
        state.participantAssessmentQuestions = []
      })
      .addCase(
        getCandidateTheoreticalAssessmentDetails.fulfilled,
        (state, action) => {
          state.isGettingDetails = false
          const { success, data, questions } = action.payload || {}
          if (success) {
            state.participantAssessmentDetails = data
            state.participantAssessmentQuestions = questions
          }
        }
      )
      .addCase(
        getCandidateTheoreticalAssessmentDetails.rejected,
        (state, action) => {
          state.isGettingDetails = false
        }
      )

    builder
      .addCase(resetTheoreticalTrainingAssessment.pending, state => {
        state.loading = true
      })
      .addCase(
        resetTheoreticalTrainingAssessment.fulfilled,
        (state, action) => {
          state.isGettingDetails = false
          const { success, data, questions } = action.payload || {}
          if (success) {
            state.loading = false
          }
        }
      )
      .addCase(resetTheoreticalTrainingAssessment.rejected, (state, action) => {
        state.loading = false
      })
  },
})

export const {
  setPayload,
  resetPayload,
  toggleFilterVisibility,
  setActiveTab,
  setParticipantsPayload,
  resetParticipantsPayload,
} = theoreticalSlice.actions
export default theoreticalSlice.reducer
